export const GetDescription = (label, datas) => {
    let items = {};
    let values, total;
    switch (label) {
        case 'archive':
            values = datas.archive[0] ? datas.archive[0] : {};
            total = datas.archive.length;
            items = {
                created: values.created,
                closed: values.closed,
                author: 'Walt Disney Imagineering',
                aname: values.aname,
                description: values.description,
                link_name: values.link_name,
                link_href: values.link_href,
                total: total,
            };
            break;
        case 'archives':
            values = datas.body[0] ? datas.body[0] : {};
            total = datas.archives.length;
            items = {
                created: '1992-04-12',
                author: 'Walt Disney Imagineering',
                name: 'Archives des attractions\ndes parcs\nDisneyland Resort Paris',
                description: values.description,
                link_name: 'Wikipedia',
                link_href: 'https://wikipedia.com',
                total: total,
            };
            break;
        case 'attraction':
            values = datas.attraction[0] ? datas.attraction[0] : {};
            total = datas.attraction.length;
            items = {
                created: '1992-04-12',
                author: 'Walt Disney Imagineering',
                aname: values.aname,
                cname: values.cname,
                cslug: values.cslug,
                oname: values.oname,
                oslug: values.oslug,
                description: values.description,
                link_name: values.link_name,
                link_href: values.link_href,
                total: total,
            }
            break;
        case 'category':
            values = datas.attractions[0] ? datas.attractions[0] : {};
            total = datas.attractions.length;
            items = {
                created: '1992-04-12',
                author: 'Walt Disney Imagineering',
                name: values.cname,
                description: values.description,
                link_name: values.link_name,
                link_href: values.link_href,
                total: total,
            };
            break;
        case 'character':
            values = datas.character[0] ? datas.character[0] : {};
            total = datas.character.length;
            items = {
                created: '1992-04-12',
                author: 'Walt Disney Imagineering',
                cname: values.cname,
                cslug: values.cslug,
                oname: values.oname,
                oslug: values.oslug,
                description: values.description,
                link_name: values.link_name,
                link_href: values.link_href,
                total: total,
            };
            break;
        case 'characters':
            values = datas.body[0] ? datas.body[0] : {};
            total = datas.characters.length;
            items = {
                created: '1992-04-12',
                author: 'Walt Disney Imagineering',
                name: 'Personnages des\nParcs Disneyland dans le monde',
                description: values.description,
                link_name: values.link_name,
                link_href: values.link_href,
                total: total,
            };
            break;
        case 'experiment':
            values = datas.experiment[0] ? datas.experiment[0] : {};
            total = datas.experiment.length;
            items = {
                created: '2002-03-16',
                author: 'Walt Disney Imagineering',
                name: values.name,
                description: values.description,
                link_name: values.link_name,
                link_href: values.link_href,
                total: total,
            };
            break;
        case 'experiments':
            values = datas.body[0] ? datas.body[0] : {};
            items = {
                created: '2002-03-16',
                name: 'Expériences\nde Jumba Jookiba',
                authors: datas.authors,
                description: values.description,
                link_name: values.link_name,
                link_href: values.link_href,
            }
            break;
        case 'family':
            values = datas.family[0] ? datas.family[0] : {};
            total = datas.attractions.length + datas.characters.length;
            items = {
                created: '1992-04-12',
                author: 'walt Disney Imagineering',
                fname: values.fname,
                fslug: values.fslug,
                description: values.description,
                link_name: values.link_name,
                link_href: values.link_href,
                total: total,
            };
            break;
        case 'festival':
            values = datas.body[0] ? datas.body[0] : {};
            total = datas.attraction.length;
            items = {
                created: '1992-04-12',
                name: 'Les festivals et parades de Disneyland Resort Paris',
                description: values.description,
                link_name: values.link_name,
                link_href: values.link_href,
                total: total,
            };
            break;
        case 'origin':
            values = datas.origin[0] ? datas.origin[0] : {};
            total = datas.attractions.length + datas.characters.length;
            items = {
                oname: values.oname,
                oslug: values.oslug,
                created: values.ocreated,
                author: values.oauthor,
                otname: values.otname, // slugify
                link_name: values.link_name,
                link_href: values.link_href,
                description: values.description,
                total: total,
            };
            break;
        case 'origins':
            values = datas.body[0] ? datas.body[0] : {};
            total = datas.ori.length;
            items = {
                created: '1937-01-01',
                author: 'Walt Disney Imagineering',
                name: 'Films et\nSéries télévisées\ndes Studios Disney',
                description: values.description,
                total: total,
            }
            break;
        case 'outlinks':
            values = datas.body[0] ? datas.body[0] : {};
            total = datas.outlinks.length;
            items = {
                created: '1992-04-12',
                author: 'Liens externes',
                name: 'Remerciements',
                description: values.description,
                link_name: 'Wikipedia',
                link_href: 'https://wikipedia.com',
                total: total,
            }
            break;
        case 'park':
            values = datas.body[0] ? datas.body[0] : '';
            total = datas.attractions.length;
            items = {
                created: values.created,
                author: values.author,
                name: values.name,
                description: values.description,
                link_name: values.link_name,
                link_href: values.link_href,
                total: total,
            }
            break;
        case 'rendez-vous':
            values = datas.body[0] ? datas.body[0] : {};
            total = datas.rencontres.length;
            items = {
                created: '1992-04-12',
                author: 'Walt Disney Imagineering',
                name: 'Rendez-vous avec\nles personnages\ndes Parcs Disneyland Paris',
                description: values.description,
                link_name: 'Wikipedia',
                link_href: 'https://wikipedia.com',
                total: total,
            };
            break;
        case 'rendez-vous-personnage':
            values = datas.character[0] ? datas.character[0] : {};
            total = datas.character.length;
            items = {
                created: values.ccreated,
                author: 'Walt Disney Imagineering',
                name: 'Rendez-vous avec\nun personnage',
                oname: values.oname,
                oroute: values.oroute,
                description: values.description,
                link_name: values.link_name,
                link_href: values.link_href,
                total: total,
            };
            break;
        case 'univers':
            values = datas.body[0] ? datas.body[0] : {};
            total = datas.attractions.length;
            items = {
                created: values.created,
                author: values.author,
                uname: values.uname,
                pname: values.pname,
                proute: values.proute,
                description: values.description,
                link_name: values.link_name,
                link_href: values.link_href,
                total: total,
            }
            break;
        default:
            values = {};
            total = 0;
            items = {};
    }
    return items;
}